define('drops/planningGraph/planningGraph',[
    'jquery',
    'lq/drop',
    'drops/planningGraph/planninggraphimpl',
    'underscore',
    'lq/util',
    'lq/style'
], function ($, Drop, PlanningGraphImpl, _, util, Style) {
    'use strict';

    function PlanningGraph(options) {
        Drop.call(this, $('<div/>'), options);

        this.data.eventing = util.convertListOfKeyValuesToObject(this.data.eventing);

        this.$element
	        .addClass('boxToBorderSize');

        this.boundaries1 = [];
        this.boundaries2 = [];

        Style.renderStyles(this, 'planninggraph-');
    };

    Drop.extend(PlanningGraph, Drop);

    PlanningGraph.typeName = 'PlanningGraph';

    PlanningGraph.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.formatter = this.piping.formatting.createFormatter();

        var self = this;
        this.piping.datasources.registerDatasourceListener(
            this.data.dataSource,
            function (rdata) {
                if (self.data.selectedBoundary1DataSource != undefined) {
                    self.piping.queryDispatcher.dispatch(
                        self.data.selectedBoundary1DataSource,
                        function (data) {
                            self.boundaries1 = data.results;
                            self.update(rdata);
                        },
                        function (queryData) {
                            queryData.pageSize = 1024;
                        });
                }

                if (self.data.selectedBoundary1DataSource != undefined) {
                    self.piping.queryDispatcher.dispatch(
                        self.data.selectedBoundary2DataSource,
                        function (data) {
                            self.boundaries2 = data.results;
                            self.update(rdata);
                        },
                        function (queryData) {
                            queryData.pageSize = 1024;
                        });
                }

                self.update(rdata);
            });

        this.prepareUi();
        this.applyPosition();
    };

    PlanningGraph.prototype.prepareUi = function () {
        var $container = $('<div />')
            .addClass('planningGraphContainer')
            .appendTo(this.$element);
        this.graph = new PlanningGraphImpl($container[0], this.piping);
    };

    PlanningGraph.prototype.getBatchOfCommands = function () {
        if (!this.graph) return [];

        var self = this;
        return {
            eventActionType: 'Batch',
            command: self.data.id,
            batch: _.map(this.graph.getOutputData(), function (barValue) {
                var data = {};
                data[self.data.startAttribute] = barValue.Start;
                data[self.data.stopAttribute] = barValue.End;

                return {
                    entityId: barValue.Id,
                    data: data
                };
            })
        };
    };

    PlanningGraph.prototype.update = function (data) {
        var self = this;
        var result = _.chain(data.results)
            .groupBy(function(item) {
                return item[self.data.beschrijvingIdOutput];
            })
            .map(function (items) {
                var firstItem = items[0];
                var bound1 = _.find(self.boundaries1, function (bound) { return bound[self.data.boundary1idOutput] == firstItem[self.data.beschrijvingIdOutput]; });
                var bound2 = _.find(self.boundaries2, function (bound) { return bound[self.data.boundary2idOutput] == firstItem[self.data.beschrijvingIdOutput]; });
                return {
                    Id: firstItem[self.data.idOutput],
                    Start: firstItem[self.data.beginOutput],
                    End: firstItem[self.data.eindeOutput],
                    SelectedTextColor: firstItem[self.data.beschrijvingTextColorOutput],
                    SelectedToolTip: firstItem[self.data.beschrijvingTooltipOutput] || firstItem[self.data.beschrijvingOutput],
                    SelectedName: firstItem[self.data.beschrijvingOutput],
                    SelectedId: firstItem[self.data.beschrijvingIdOutput],
                    SelectedDescription: firstItem[self.data.naamOutput],
                    Boundary1start: bound1 ==null ? null : bound1[self.data.boundary1startOutput],
                    Boundary1stop: bound1 == null ? null : bound1[self.data.boundary1stopOutput],
                    Boundary2start: bound2 == null ? null : bound2[self.data.boundary2startOutput],
                    Boundary2stop: bound2 == null ? null : bound2[self.data.boundary2stopOutput],
                    Plannings: _.map(items, function (item) {
                        return {
                            Id: item[self.data.idSelectieOutput],
                            Text: item[self.data.naamOutput],
                            _origStart: self.data.usingDateTime ? self.formatter.parseLicquidDate(item[self.data.startSelectieOutput]) : item[self.data.startSelectieOutput],
                            _origEnd: self.data.usingDateTime ? self.formatter.parseLicquidDate(item[self.data.stopSelectieOutput]) : item[self.data.stopSelectieOutput],
                            isPreference: item[self.data.isPreference],
                            isFlagged: item[self.data.isFlagged],
                            isSpecial: item[self.data.isSpecial],
                            dynamicBarColor: item[self.data.dynamicBarColor],
                            dynamicTextColor: item[self.data.dynamicTextColor],
                            Tooltip: self.data.tooltip === undefined ? "" : item[self.data.tooltip],
                            Start: self.data.usingDateTime ? self.formatter.parseLicquidDate(item[self.data.startSelectieOutput]) : item[self.data.startSelectieOutput],
                            End: self.data.usingDateTime ? self.formatter.parseLicquidDate(item[self.data.stopSelectieOutput]) : item[self.data.stopSelectieOutput],
                            EventArgument: item[self.data.eventArgument]
                        };
                    }),
                    Total: function () {
                        return _.reduce(this.Plannings, function (total, planning) {
                            var newTotal = total + planning.End - planning.Start;
                            if (isNaN(newTotal)) return total + ((new Date(planning.End) - new Date(planning.Start)) / 1000);
                            return newTotal;
                        }, 0);
                    }
                };
            })
            .value();

        this.planningList = result;

        if ($(this.graph.container).find(".rowItems").length == 1) {
            var prevScrollPosition = $(this.graph.container).find(".rowItems")["0"].scrollTop;
        }

        this.drawPlanningGraph();

        if (prevScrollPosition != undefined) {
            $(this.graph.container).find(".rowItems")["0"].scrollTop = prevScrollPosition;
        }
    };

    PlanningGraph.prototype.drawPlanningGraph = function () {
        this.graph.draw(this, this.retrievePlanningGraphData());

        if (this.data.eventing && this.data.eventing.clicked && this.data.eventing.clicked.enabled === true) {
            var self = this;
                
            this.graph.clickedSelection = function (id) {
                var scheduleUnit = _.chain(self.planningList)
                    .map(function (s) {
                        return s.Plannings;
                    })
                    .flatten()
                    .find(function (su) {
                        return su.Id === id;
                    })
                    .value();

                if (self.graph.hasUnsavedChanges()) {
                    if (self.data.eventing && self.data.eventing.changed && self.data.eventing.changed.enabled === true)
                        self.triggerEvent(self.data.eventing.changed.raisedEventName, scheduleUnit.EventArgument);
                } else {
                    if (self.data.eventing && self.data.eventing.clicked && self.data.eventing.clicked.enabled === true)
                        self.triggerEvent(self.data.eventing.clicked.raisedEventName, scheduleUnit.EventArgument);
                }
                
                self.selectedBarId = id;
                $(".planningPeriodActual.selected").removeClass("selected");
                $(".planningPeriodActual[itemid='" + id + "']").addClass("selected");
            };
        }
        if (this.data.eventing && this.data.eventing.clickedOnDescription && this.data.eventing.clickedOnDescription.enabled === true) {
            var self = this;
            this.graph.clickedOnDescription = function (id) {
                var scheduleUnit = _.chain(self.planningList)
                            .find(function (su) { return su.Id == id; })
                            .value();

                self.triggerEvent(self.data.eventing.clickedOnDescription.raisedEventName, scheduleUnit.SelectedId);
            };
        }

        this.fixHeight();
    };
        
    PlanningGraph.prototype.fixHeight = function () {
        var rowHeight = parseInt(this.$element.find('.row').css('height'));
        var height;

        if (this.data.visibleRows > 0) {
            height = this.data.visibleRows * (rowHeight + 1);
        } else {
            var legendFontSize = this.$element
                .find('.gridLabel')
                .css('font-size');

            height = this.data.size.y - rowHeight - 1;
            height -= 2 * parseInt(legendFontSize); //hour labels
            height -= 2 * parseInt(legendFontSize); //day labels
            height = Math.floor(height / (rowHeight)) * (rowHeight + 1);
        }
            
        this.$element
            .find('.tablePlanningItems')
            .css({
                'height': height + 'px'
            });
    };

    PlanningGraph.prototype.convertToNumber = function (string) {
        if (typeof string == 'number') {
            return string;
        } else {
            return parseFloat(string);
        }
    };

    PlanningGraph.prototype.convertToBoolean = function (string) {
        if (typeof string == 'boolean') {
            return string;
        } else {
            return string == 'true';
        }
    };

    PlanningGraph.prototype.retrievePlanningGraphData = function () {
        return {
            readOnly: this.data.readOnly,
            testData: this.convertToBoolean(this.data.testData),
            showAsTime: this.convertToBoolean(this.data.showAsTime),
            usingDateTime: this.data.usingDateTime,
            fromDateParameter: this.data.fromDateParameter,
            toDateParameter: this.data.toDateParameter,
            rangeMin: this.convertToNumber(this.data.rangeMin),
            rangeMax: this.convertToNumber(this.data.rangeMax),
            interval: this.convertToNumber(this.data.interval),
            intervalGrid: this.convertToNumber(this.data.intervalGrid),
            intervalGridMajor: this.convertToNumber(this.data.intervalGridMajor),
            intervalGridLabel: this.convertToNumber(this.data.intervalGridLabel),
            decimalPrecision: this.convertToNumber(this.data.decimalPrecision),
            descriptionLabel: this.data.descriptionLabel,
            totalLabel: this.data.totalLabel,
            visibleRows: this.convertToNumber(this.data.visibleRows),

            barValues: this.getPlanningData(),

            gridLines: this.getGridData(this.data.intervalRedGrid),
            showGrid: this.convertToBoolean(this.data.showGrid),
            showAxisLabels: this.convertToBoolean(this.data.showAxisLabels),
            showAxisLabelsTop: this.convertToBoolean(this.data.showAxisLabelsTop),
            isWithPreferredValues: this.convertToBoolean(this.data.isWithPreferredValues)
        };
    };

    PlanningGraph.prototype.getGridData = function (values) {
        var gridData = [];
        try {
            var val = values.split(";");
            for (var i = 0; i < val.length; i++) {
                gridData[i] = JSON.parse(JSON.stringify({ Value: 3600 * this.convertToNumber(val[i]) }));
            }
        } catch (exception) { }
        return gridData;
    };

    PlanningGraph.prototype.getPlanningData = function () {
        var planningItems = [];

        if (!this.data.testData || this.data.testData.length === 0) {
            return this.planningList;
        }

        var pi_plan_1 = {
            Id: "\\plan\\01",
            Text: "Item",
            _origStart: 8 * 3600,
            _origEnd: 11 * 3600,
            Start: 8 * 3600,
            End: 11 * 3600
        };

        var pi_plan_2 = {
            Id: "\\plan\\02",
            Text: "Niet Item",
            _origStart: 13 * 3600,
            _origEnd: 17 * 3600,
            Start: 13 * 3600,
            End: 17 * 3600
        };

        var pi = {
            Id: "test\\0",
            Start: 8 * 3600,
            End: 18 * 3600,
            SelectedName: "John. ",
            SelectedDescription: "Item",
            Plannings: new Array(),
        };

        pi.Plannings[0] = pi_plan_1;
        pi.Plannings[1] = pi_plan_2;

        for (var i = 10 ; i < 25; i++) {
            var planning = JSON.parse(JSON.stringify(pi));

            planning.Total = function () {
                var total = 0;
                for (var i = 0; i < this.Plannings.length; i++) {
                    total += this.Plannings[i].End - this.Plannings[i].Start;
                }
                return total;
            };

            if (i % 5 == 0) {
                planning.Plannings[0].isFlagged = 1;
            }

            planning.Id += i;
            planning.SelectedName += i - 9;
            planningItems[i - 10] = planning;

            planning.Plannings[0].Id = planning.Id + planning.Plannings[0].Id;
            planning.Plannings[1].Id = planning.Id + planning.Plannings[1].Id;
        }

        return planningItems;
    };

    return PlanningGraph;
});
